import { useEffect } from 'react';
import { Hub } from 'aws-amplify/utils';

export type AuthFailureReason =
  | 'signInWithRedirect_failure'
  | 'tokenRefresh_failure';

export const useAmplifyAuthHub = (
  onSignIn: () => void,
  onFailure: (reason: AuthFailureReason) => void,
) => {
  useEffect(() => {
    const unsubscribe = Hub.listen('auth', ({ payload }) => {
      if (
        payload.event === 'signInWithRedirect' ||
        payload.event === 'signedIn'
      ) {
        onSignIn();
      }
      if (
        payload.event === 'signInWithRedirect_failure' ||
        payload.event === 'tokenRefresh_failure'
      ) {
        onFailure(payload.event);
      }
    });

    return unsubscribe;
  }, [onSignIn, onFailure]);
};
